import * as EP from "./endpoints";
import HTTP from "@/packages/http";

export const ExportService = {
  saveConsignee(formData) {
    return HTTP.post(EP.SAVE_CONSIGNEE, { ...formData }).then(({ data }) => data);
  },
  getConsignees(country) {
    return HTTP.get(EP.GET_CONSIGNEES + country).then(({ data }) => data);
  },
  getExportJobs(timePeriodId) {
    return HTTP.get(EP.GET_EXPORT_JOBS + timePeriodId).then(({ data }) => data);
  },
  editExportJob(data) {
    return HTTP.get(EP.EDIT_EXPORT_JOB + data.exportJobId).then(({ data }) => data);
  },
  deleteExportJob(data) {
    return HTTP.delete(EP.DELETE_EXPORT_JOB + data.exportJobId).then(({ data }) => data);
  },
  saveExportJob(formData) {
    return HTTP.post(EP.SAVE_EXPORT_JOB, { ...formData }).then(({ data }) => data);
  },
  generateChecklist(data) {
    return HTTP.get(EP.GENERATE_CHECKLIST + data.exportJobId).then(({ data }) => data);
  },
  generateFlatfile(data) {
    return HTTP.get(EP.GENERATE_FLATFILE + data.exportJobId).then(({ data }) => data);
  }
};
